module.exports = __webpack_public_path__ + "static/media/monitor.ade84bc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/monitor.png
// module id = 2438
// module chunks = 0